<template>
  <v-container fluid>
    <v-card class="pt-10 primary--text" color="transparent" flat>
      <v-row>
        <div>
                <router-link
                  :to="{ name: 'HomeView' }"
                  class="primary--text text-center text-lg-left text-md-left"
                  style="text-decoration: none"
                >
                  <h2>Cinematic Celebration</h2>
                </router-link>
                <div class="mb-4 mb-lg-2 mb-md-2 primary--text text-left">
                <b>Address</b>
              </div>
              </div>
        <v-col cols="12">
          <v-row no-gutters justify="center" class="footer text-center">
            <template v-if="!isLoading && locations.length > 0">
            <v-col
              cols="12"
              lg="3"
              md="3"
              v-for="location in locations"
                :key="location.id"
              class="text-left mb-8 mb-lg-0 mb-md-0 pl-4"
            >
              
              
              

              <div><b>{{ location.name }}</b></div>

              <div>
                {{ location.address }}
              </div>

              <div class="text-left mt-2">
                <b>Phone Number: </b>
                {{ location.phone }}
              </div>
        
            </v-col>
            </template>

            <v-col
              cols="12"
              lg="3"
              md="3"
              class="text-left mb-8 mb-lg-0 mb-md-0 pl-4"
            >
              <div class="mb-4 mb-lg-2 mb-md-2 primary--text">
                <b>Quick Links</b>
              </div>
              <v-row no-gutters justify="start" class="footer">
                <v-col cols="5" lg="5" md="5">
                  <div class="footer-links">
                    <div>
                      <router-link
                        exact
                        :to="{ name: 'HomeView', hash: '#about-us' }"
                        class="primary--text"
                        style="text-decoration: none"
                        >About Us
                      </router-link>
                    </div>
                    <div>
                      <router-link
                        exact
                        :to="{ name: 'HomeView', hash: '#our-space' }"
                        class="primary--text"
                        style="text-decoration: none"
                        >Our Space
                      </router-link>
                    </div>
                    <!-- <div>
                                            <router-link exact :to="{ name: 'HomeView', hash: '#testimonial' }"
                                                class="primary--text" style="text-decoration: none">Testimonial
                                            </router-link>
                                        </div> -->
                    <div>
                      <router-link
                        exact
                        :to="{ name: 'HomeView', hash: '#contact-us' }"
                        class="primary--text"
                        style="text-decoration: none"
                        >Contact us
                      </router-link>
                    </div>
                  </div>
                </v-col>
                <v-col cols="7" lg="5" md="5">
                  <div class="footer-links">
                    <div>
                      <router-link
                        class="primary--text"
                        style="text-decoration: none"
                        :to="{ name: 'TermsAndConditionsView' }"
                      >
                        Terms & Conditions
                      </router-link>
                    </div>
                    <div>
                      <router-link
                        class="primary--text"
                        style="text-decoration: none"
                        :to="{ name: 'RefunfPolicyView' }"
                      >
                        Refund Policy
                      </router-link>
                    </div>
                    <div>
                      <router-link
                        class="primary--text"
                        style="text-decoration: none"
                        :to="{ name: 'PrivacyPolicyView' }"
                      >
                        Privacy Policy
                      </router-link>
                    </div>
                    <!-- <div>
                                            <router-link class="primary--text" style="text-decoration: none"
                                                :to="{ name: 'AdminView' }">
                                                Admin Login</router-link>
                                        </div> -->
                  </div>
                </v-col>
              </v-row>
            </v-col>

            
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="pt-0 pt-lg-3 pt-md-3">
                Copyright ©2025 All Rights Reserved | Cinematic Celebration
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import { getAllLocations } from "@/services/booking/booking.service";

export default {
  name: "AppFooter",

  data() {
    return {
      locations: [],
      isLoading: true,
    };
  },

  async mounted() {
    try {
      const res = await getAllLocations();
      this.locations = res.data.data;
    } catch (error) {
      console.error("Failed to fetch locations:", error);
    } finally {
      this.isLoading = false;
    }
  },

  components: {},
  methods: {
    goSocial() {
      window.open("https://www.instagram.com/cinematic_celebration.in");
    },
  },
};
</script>
<style scoped>
.footer-links > div {
  margin-bottom: 8px;
}
</style>
